import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';

// Link for a brandId
export function LinkBrand(t0) {
  const $ = _c(4);
  const {
    brandId,
    children,
    className
  } = t0;
  const t1 = `/entities/${brandId}`;
  let t2;
  if ($[0] !== children || $[1] !== className || $[2] !== t1) {
    t2 = <Link href={t1} className={className}>{children}</Link>;
    $[0] = children;
    $[1] = className;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}